import React from 'react';
import classNames from 'clsx';

import { CHAPTERS, COMMENTS, HIGHLIGHTS, SLIDES } from '../constants/playerMark';
import {
  CUSTOM_TAG_VALUE,
  SYSTEM_TAG_BRANDS,
  SYSTEM_TAG_CC,
  SYSTEM_TAG_PEOPLE,
  SYSTEM_TAG_TEXT,
} from '@/modules/common/constants/label';

import { getFormattedDuration } from '../../../helpers/dateTime';
import { getFormattedLogList } from '../../../helpers/deepSearch';

import SlideSvg from '../components/SlideSvg';
import {
  CustomBrandsCircular,
  CustomCcCircular,
  CustomCommentsCircular,
  CustomLabelTagCircular,
  CustomPeopleCircular,
  CustomTextCircular,
} from '@/mui/components/CustomIcon';

import styles from '../Player.module.scss';

const pointMarksCollection = {
  [SYSTEM_TAG_PEOPLE]: {
    Icon: CustomPeopleCircular,
    pointMark: true,
  },
  [SYSTEM_TAG_BRANDS]: {
    Icon: CustomBrandsCircular,
    pointMark: true,
  },
  [SYSTEM_TAG_CC]: {
    Icon: CustomCcCircular,
    pointMark: true,
  },
  [SYSTEM_TAG_TEXT]: {
    Icon: CustomTextCircular,
    pointMark: true,
  },
  [COMMENTS]: {
    Icon: CustomCommentsCircular,
    pointMark: true,
  },
  [SLIDES]: {
    Icon: SlideSvg,
    pointMark: true,
  },
  [CUSTOM_TAG_VALUE]: {
    Icon: CustomLabelTagCircular,
    pointMark: true,
  },
  [HIGHLIGHTS]: {
    pointMark: false,
  },
  [CHAPTERS]: {
    modifier: styles.Mark___chapter,
    pointMark: false,
  },
};

export const generateContent = (mark) => {
  const content = document.createElement('div');

  if (Object.keys(pointMarksCollection).includes(mark.type)) {
    const { Icon, pointMark, modifier } = pointMarksCollection[mark.type];

    content.style.color = mark.color;

    content.className = classNames(styles.Mark, modifier, {
      [styles.Mark___line]: !pointMark,
    });

    if (Icon) {
      import('react-dom/server').then((dom) => {
        if (content && dom?.default) {
          content.innerHTML = dom.default.renderToStaticMarkup(<Icon className={styles.MarkIcon} value={mark.value} />);
        }
      });
    }

    return content;
  }

  return null;
};

const generateDeepSearchTooltip = (mark) => {
  const formattedTime = [getFormattedDuration(mark.time), !!mark.endTime && getFormattedDuration(mark.endTime)]
    .filter(Boolean)
    .join(' - ');

  const formattedValue = getFormattedLogList(
    mark.value,
    mark.highlights.map((item) => item.value),
    mark.stopWords,
    mark.itemId,
  )
    .reduce(
      (acc, item$) =>
        item$.isHighlighted && !acc.some((value$) => value$ === item$.value) ? acc.concat(item$.value) : acc,
      [],
    )
    .join(', ');

  const tooltip = document.createElement('div');

  tooltip.innerHTML = `${formattedTime}</br>${formattedValue}`;

  return tooltip;
};

export const generateCommentTooltip = (mark) => {
  const tooltip = document.createElement('div');

  tooltip.innerHTML = `${mark.count} ${mark.count <= 1 ? 'Comment' : 'Comments'}`;

  return tooltip;
};

export const generateTooltip = (mark) => {
  if ([SYSTEM_TAG_PEOPLE, SYSTEM_TAG_BRANDS, SYSTEM_TAG_CC, SYSTEM_TAG_TEXT, CUSTOM_TAG_VALUE].includes(mark.type)) {
    return generateDeepSearchTooltip(mark);
  }

  if (mark.type === COMMENTS) {
    return generateCommentTooltip(mark);
  }

  return null;
};
